import { initSimpleNavigation } from './components/simple-navigation.js';
import { initMainSiteNavigation } from './components/main-site-navigation.js';
import { initFloorplan } from './components/floorplan.js';
import { initStickyHeader } from './components/header.js';
import { initGallery } from './components/gallery.js';
import { initImageGallery } from './components/image-gallery.js';
import { initFooterFitText } from './components/main-site-footer.js';
import { initFaqCategoryNav } from './components/faq-category-nav.js';
initSimpleNavigation();
initMainSiteNavigation();
initStickyHeader();
initFloorplan();
initGallery();
initImageGallery();
initFooterFitText();
initFaqCategoryNav();
